import axios from 'axios';

//分页查询购买商品
export function productList(params) {
  return axios({
    url: '/mall/app/after/sale/product',
    method: 'get',
    params,
  });
}

export function recordList(params) {
  return axios({
    url: '/mall/app/after/sale/record',
    method: 'get',
    params,
  });
}

export function processingList(params) {
  return axios({
    url: '/mall/app/after/sale/processing',
    method: 'get',
    params,
  });
}

//取消申请

export function cancelApply(id) {
  return axios({
    url: 'mall/app/after/sale/cancel/' + id,
    method: 'put',

  });
}

//查询售后申请原因
export function applyReason(params) {
  return axios({
    url: '/mall/app/after/sale/reasons',
    method: 'get',
    params
  });
}

//上传图片
export function uploadImage(data) {
  return axios({
    url: '/mall/common/picture',
    method: 'post',
    data
  });
}


//申请售后
export function apply(data) {
  return axios({
    url: '/mall/app/after/sale/apply',
    method: 'post',
    data
  });
}

//填写退货单
export function returnForm(data) {
  return axios({
    url: '/mall/app/after/sale/return_form',
    method: 'put',
    data
  });
}


//查询售后详情
export function detail(id) {
  return axios({
    url: '/mall/app/after/sale/' + id,
    method: 'get'
  });
}

//撤销申请
export function cancel(id) {
  return axios({
    url: '/mall/app/after/sale/cancel/' + id,
    method: 'put'
  });
}

//订单详情
export function order(id) {
  return axios({
    url: '/mall/app/order/' + id,
    method: 'get'
  });
}